import type { ISerialize } from '@/objects/ISerialize';
import type { AttachUnknownTagToContestantAttachType } from './../enums/AttachUnknownTagToContestantAttachType';

export class AttachUnknownTagToContestantRequest implements ISerialize {
    public AttachType: AttachUnknownTagToContestantAttachType;

    public Bib: number | null;

    public Chip: string | null;

    public ContestantID: number;

    public RawTag: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        AttachType?: AttachUnknownTagToContestantAttachType;
        Bib?: number | null;
        Chip?: string | null;
        ContestantID?: number;
        RawTag?: string | null;
    }) {
        this.AttachType = values.AttachType ?? 'Bib';

        this.Bib = values.Bib ?? null;

        this.Chip = values.Chip ?? null;

        this.ContestantID = values.ContestantID ?? 0;

        this.RawTag = values.RawTag ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"AttachType": ${this.AttachType == 'Bib' ? 0 : this.AttachType == 'Chip1' ? 2 : this.AttachType == 'Chip2' ? 3 : 0}` +
            ',' +
            `"Bib": ${JSON.stringify(this.Bib)}` +
            ',' +
            `"Chip": ${JSON.stringify(this.Chip)}` +
            ',' +
            `"ContestantID": ${JSON.stringify(this.ContestantID)}` +
            ',' +
            `"RawTag": ${JSON.stringify(this.RawTag)}` +
            '}'
        );
    }

    /**
     * Creates an instance of AttachUnknownTagToContestantRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        AttachType?: AttachUnknownTagToContestantAttachType;
        Bib?: number | null;
        Chip?: string | null;
        ContestantID?: number;
        RawTag?: string | null;
    }): AttachUnknownTagToContestantRequest {
        return new AttachUnknownTagToContestantRequest(values);
    }

    public static _FromServerJson(json: any): AttachUnknownTagToContestantRequest {
        return new AttachUnknownTagToContestantRequest({
            AttachType: json.AttachType == 0 ? 'Bib' : json.AttachType == 2 ? 'Chip1' : json.AttachType == 3 ? 'Chip2' : 'Bib',
            Bib: json.Bib ?? null,
            Chip: json.Chip ?? '',
            ContestantID: json.ContestantID,
            RawTag: json.RawTag ?? '',
        });
    }

    /**
     * Creates an instance of AttachUnknownTagToContestantRequest from another instance of AttachUnknownTagToContestantRequest.
     * @param other The AttachUnknownTagToContestantRequest you want to clone
     * @returns A cloned AttachUnknownTagToContestantRequest
     */
    public static FromOther(other: AttachUnknownTagToContestantRequest): AttachUnknownTagToContestantRequest {
        return AttachUnknownTagToContestantRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return AttachUnknownTagToContestantRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'AttachUnknownTagToContestantRequest';
}
